import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmPasswordValidator } from '../registration/confirm-password.validator';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmRegistration } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-authentication-api-client';
import { AuthenticationAPIService } from '../../services/authenticationAPI.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  isLoading: boolean = false;
  passwordReseted: boolean = false;
  hasError: boolean = false;
  token: string;
  email: string;
  strongPasswordRegex: RegExp = /^(?=.*\d)(?=.*[!@#$%^&*.])[a-zA-Z0-9!@#$%^&*.].{8,}$/;

  // private fields
  constructor(private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    private authenticationAPIService: AuthenticationAPIService) {
  }

  ngOnInit(): void {
    this.initForm();
    this.activatedRoute.queryParams.subscribe(async params => {
      this.token = params['token'];
      this.email = params['email'];
      const isTokenValid = await this.authenticationAPIService.checkTokenValidity(this.email, this.token);
      if (!isTokenValid) {
        this.toastr.error("Your registration link is invalid or has expired. Please request a new one.", "Failed");
        this.router.navigate(['/auth/login']);
      }
    });
  }

  initForm() {
    this.resetPasswordForm = this.fb.group({
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.strongPasswordRegex)
        ]),
      ],
      cPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.strongPasswordRegex)
        ]),
      ],
    },
      {
        validator: ConfirmPasswordValidator.MatchPassword,
      });
  }

  submit() {
    this.passwordReseted = false;
    this.hasError = false;
    const confirmedRegistrationModel = new ConfirmRegistration();
    confirmedRegistrationModel.email = this.email;
    confirmedRegistrationModel.password = this.resetPasswordForm.controls["password"].value;
    confirmedRegistrationModel.token = this.token;

    this.isLoading = true;
    this.authenticationAPIService.confirmRegistration(confirmedRegistrationModel)
      .then((r) => {
        this.passwordReseted = true;
        this.router.navigate(['/auth/login']);
        this.toastr.success('Account created', 'Success');
      }).catch((err) => this.hasError = true)
      .finally(() => {
        this.isLoading = false;
        this.changeDetectorRef.detectChanges();
      });
  }
}
